/**
 * API Client para Módulo de Mitzvot
 * Comunicación con backend /api/mitzvot
 */

import api from './api';

// ============================================================================
// Mandamientos (Mitzvot)
// ============================================================================

/**
 * Obtener todos los mandamientos con filtros y paginación
 */
export const getAllMitzvot = async (params = {}) => {
  try {
    const response = await api.get('/mitzvot', { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener mandamientos:', error);
    throw error;
  }
};

/**
 * Obtener mandamiento por ID
 */
export const getMitzvahById = async (id) => {
  try {
    const response = await api.get(`/mitzvot/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener mandamiento:', error);
    throw error;
  }
};

/**
 * Obtener mandamiento por número (1-613)
 */
export const getMitzvahByNumber = async (number) => {
  try {
    const response = await api.get(`/mitzvot/number/${number}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener mandamiento por número:', error);
    throw error;
  }
};

/**
 * Buscar mandamientos por texto
 */
export const searchMitzvot = async (query, limit = 20) => {
  try {
    const response = await api.get('/mitzvot/search', {
      params: { q: query, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error en búsqueda de mandamientos:', error);
    throw error;
  }
};

/**
 * Obtener mandamientos por parashá
 */
export const getMitzvotByParasha = async (parashaId) => {
  try {
    const response = await api.get(`/mitzvot/parasha/${parashaId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener mandamientos por parashá:', error);
    throw error;
  }
};

/**
 * Obtener mandamientos por libro
 */
export const getMitzvotByBook = async (bookId) => {
  try {
    const response = await api.get(`/mitzvot/book/${bookId}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener mandamientos por libro:', error);
    throw error;
  }
};

/**
 * Obtener estadísticas de mandamientos
 */
export const getMitzvotStatistics = async () => {
  try {
    const response = await api.get('/mitzvot/statistics');
    return response.data;
  } catch (error) {
    console.error('Error al obtener estadísticas:', error);
    throw error;
  }
};

// ============================================================================
// Perspectivas
// ============================================================================

/**
 * Obtener todas las perspectivas de un mandamiento
 */
export const getAllPerspectives = async (mitzvahId, perspectiveNames = null) => {
  try {
    const params = perspectiveNames ? { names: perspectiveNames.join(',') } : {};
    const response = await api.get(`/mitzvot/${mitzvahId}/perspectives`, { params });
    return response.data;
  } catch (error) {
    console.error('Error al obtener perspectivas:', error);
    throw error;
  }
};

/**
 * Obtener resumen de perspectivas disponibles
 */
export const getPerspectivesSummary = async (mitzvahId) => {
  try {
    const response = await api.get(`/mitzvot/${mitzvahId}/perspectives/summary`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener resumen de perspectivas:', error);
    throw error;
  }
};

/**
 * Obtener perspectiva Rambam
 */
export const getRambamPerspective = async (mitzvahId) => {
  try {
    const response = await api.get(`/mitzvot/${mitzvahId}/perspectives/rambam`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener perspectiva Rambam:', error);
    throw error;
  }
};

// ============================================================================
// CRUD (Admin)
// ============================================================================

/**
 * Crear nuevo mandamiento
 */
export const createMitzvah = async (data) => {
  try {
    const response = await api.post('/mitzvot', data);
    return response.data;
  } catch (error) {
    console.error('Error al crear mandamiento:', error);
    throw error;
  }
};

/**
 * Actualizar mandamiento
 */
export const updateMitzvah = async (id, data) => {
  try {
    const response = await api.put(`/mitzvot/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar mandamiento:', error);
    throw error;
  }
};

/**
 * Eliminar mandamiento
 */
export const deleteMitzvah = async (id) => {
  try {
    const response = await api.delete(`/mitzvot/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar mandamiento:', error);
    throw error;
  }
};

// ============================================================================
// Helpers
// ============================================================================

/**
 * Helper para construir query params de filtros
 */
export const buildFilterParams = (filters) => {
  const params = {};
  
  if (filters.search) params.search = filters.search;
  if (filters.tipo) params.tipo = filters.tipo;
  if (filters.perspectiva) params.perspectiva = filters.perspectiva;
  if (filters.categorias && filters.categorias.length > 0) {
    params.categorias = JSON.stringify(filters.categorias);
  }
  if (filters.libro) params.libro = filters.libro;
  if (filters.parasha) params.parasha = filters.parasha;
  if (filters.minNumber) params.min = filters.minNumber;
  if (filters.maxNumber) params.max = filters.maxNumber;
  if (filters.page) params.page = filters.page;
  if (filters.limit) params.limit = filters.limit;
  if (filters.orderBy) params.orderBy = filters.orderBy;
  if (filters.orderDir) params.orderDir = filters.orderDir;
  
  return params;
};

export default {
  getAllMitzvot,
  getMitzvahById,
  getMitzvahByNumber,
  searchMitzvot,
  getMitzvotByParasha,
  getMitzvotByBook,
  getMitzvotStatistics,
  getAllPerspectives,
  getPerspectivesSummary,
  getRambamPerspective,
  createMitzvah,
  updateMitzvah,
  deleteMitzvah,
  buildFilterParams
};



